module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isUserLocationSet) ? _c('app-header', {
    on: {
      "logout": _vm.logoutUser
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.isUserLocationSet) ? _c('app-footer') : _vm._e()], 1), _vm._v(" "), _c('app-login', {
    attrs: {
      "isOpenModal": _vm.showLoginModal
    }
  }), _vm._v(" "), _c('app-signup', {
    attrs: {
      "isOpenModal": _vm.showSignupModal
    }
  }), _vm._v(" "), _c('app-reset', {
    attrs: {
      "isOpenModal": _vm.showResetModal
    }
  }), _vm._v(" "), _c('app-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }]
  }), _vm._v(" "), _c('mobile-basket', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileBasket),
      expression: "showMobileBasket"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ebd8e98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 214
// module chunks = 14